import React, { useState, useEffect, useCallback } from "react";
import { setTitle } from "../helpers/MetaTag";
import ButtonFile from "../components/form/ButtonFile";
import Table from "../components/elements/table/Table";
import Button from "../components/form/Button";
import Select from "../components/form/Select";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { reorder } from "../helpers";
import toastr from "toastr";
import moment from "moment";
import NoDataFound from "../components/NoDataFound";
import Searching from "../components/Searching";
import { useSelector } from "react-redux";

import { postData } from "../services/api";
import { useTranslation } from "react-i18next";
import { CSVLink, CSVDownload } from "react-csv";
import Papa from "papaparse";
import ManageEmployeePopup from "../components/popup/ManageEmployeePopup";
import DeletePopup from "../components/DeletePopup";
import ReactPaginate from "react-paginate";
import TableSkeleton from "../components/loader/TableSkeleton";
import { Tooltip } from "react-tooltip";
import EmployeeUploadPopup from "../components/popup/EmployeeUploadPopup";
const CompanyEmployees = () => {
  setTitle(
    "Succession Planning Software for your Business with Succession Now | Company Employees"
  );
  const [loading, setLoading] = useState(true);
  const { i18n, t } = useTranslation();
  const role = localStorage.getItem("role");
  const user = useSelector((state) => state.auth?.user);
  const time = new Date().getTime();
  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const [noOfPage, setNoOfPage] = useState(0);
  const [position, setPosition] = useState([]);
  const [sortKey, setSortKey] = useState("created_at");
  const [sortValue, setSortValue] = useState(-1);
  const [sortQuery, setSortQuery] = useState("");
  const [totalDataCount, setTotalDataCount] = useState(0);
  const [startDataCount, setStartDataCount] = useState(0);
  const [endDataCount, setEndDataCount] = useState(0);
  const [csvData, setCsvData] = useState([]);
  const [isUpdateFile, setIsUpdateFile] = useState(false);
  const [actionValue, setActionValue] = useState({});
  const [enabledManageEmployeePopup, setEnabledManageEmployeePopup] =
    useState(false);
  const [details, setDetails] = useState({});
  const [currentId, setCurrentId] = useState("");
  const [enabledDeletePopup, setenabledDeletePopup] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false);
  const [enabledUploadEmployeePopup, setEnabledUploadEmployeePopup] =
    useState(false);

  const loadPositionList = useCallback(async () => {
    try {
      const result = await postData("position/list", {
        sortQuery: { created_at: 1 },
        status: 1,
        isBoardMember: 2,
      });
      if (result.data) {
        setPosition(
          result.data?.sort((a, b) => a?.name?.localeCompare(b?.name))
        );
      } else {
        console.log("Position list message", result.message);
      }
    } catch (error) {
      console.log("Error position list catch", error.message);
    }
  }, []);

  useEffect(() => {
    loadPositionList();
  }, [loadPositionList]);

  const loadList = useCallback(async () => {
    setLoading(true);
    try {
      const result = await postData("employee/list", {
        limit: limit,
        offset: offset,
        sortQuery: sortQuery,
      });
      if (result.data) {
        setCsvData(result.data);
      }
      setTotalDataCount(result.count);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      console.log(err.message);
    }
  }, [limit, offset, sortQuery, isUpdateFile, actionValue]);

  useEffect(() => {
    loadList();
  }, [loadList]);

  useEffect(() => {
    setNoOfPage(Math.ceil(totalDataCount / limit));
    const startItem = Number(totalDataCount > 0 ? 1 : 0);
    const endItem = Math.min(startItem + limit - 1, totalDataCount);
    setStartDataCount(startItem);
    setEndDataCount(endItem);
  }, [limit, totalDataCount]);

  const handelUpdate = async (id, val, field, index) => {
    try {
      setCsvData(
        csvData.map((it, idx) => {
          if (idx === index) {
            return { ...it, [field]: val };
          } else {
            return it;
          }
        })
      );
      const result = await postData("employee/update", {
        id: id,
        [field]: val !== "" ? val : null,
        type: "position",
      });
      if (result.status && result.status === 200) {
        toastr.success(result.message);
      } else {
        toastr.error(result.message);
      }
    } catch (error) {
      toastr.error(error.message);
    }
  };

  const handlePageClick = (event) => {
    const newOffset = (event.selected * limit) % totalDataCount;
    console.log(
      `User requested page number ${event.selected}, which is offset ${newOffset}`
    );
    setOffset(newOffset);
    const startItem = Number(newOffset + 1);
    const endItem = Math.min(startItem + limit - 1, totalDataCount);
    setStartDataCount(startItem);
    setEndDataCount(endItem);
  };
  useEffect(() => {
    if (actionValue && actionValue.button_type === "delete") {
      const loadDeleteRecord = async () => {
        setIsUpdate(false);
        try {
          const statusData = await postData("employee/delete", {
            id: actionValue?.row_id,
          });
          if (statusData.data) {
            const index = csvData.findIndex(
              (item) => item._id === actionValue?.row_id
            );
            if (index !== -1) {
              csvData.splice(index, 1);
              setCsvData(
                csvData.map((it) => {
                  return it;
                })
              );
            }
            setIsUpdate(true);
          } else {
            toastr.error(statusData.message);
          }
        } catch (error) {
          toastr.error(error.message);
        }
      };
      loadDeleteRecord();
    }
  }, [actionValue]);

  return (
    <>
      <div className="relative flex justify-between items-center mb-4 flex-wrap sm:flex-nowrap gap-y-4">
        <div className="text-xl md:text-3xl text-slate-800 font-bold">
          {t("company_employees") + " - " + user?.company_name}
        </div>

        <div className="sm:ml-auto flex justify-start sm:justify-end items-center gap-2 flex-wrap">
          <div
            className="sm:ml-auto flex justify-end items-center"
            data-tooltip-id={`buttons${1}`}
            data-tooltip-place="bottom"
          >
            <Button
              buttonClasses=""
              buttonLabelClasses=""
              buttonType={"button"}
              buttonIcon={"fa-light fa-arrow-right-to-arc"}
              buttonIconPosition={"left"}
              buttonLabel={t("add_employee")}
              buttonHasLink={false}
              functions={() => setEnabledManageEmployeePopup(true)}
            />

            <Tooltip
              id={`buttons${1}`}
              className="!text-xs !bg-dark-teal-600 z-50 rounded py-3 px-6"
              render={() => (
                <div className="gap-x-1">
                  <div className="text-[13px] font-normal leading-none flex items-center">
                    <div className="font-semibold">Add New Employee</div>
                  </div>
                </div>
              )}
            />
          </div>
          <Button
            buttonClasses=""
            buttonLabelClasses=""
            buttonType={"button"}
            buttonIcon={"fa-light fa-upload"}
            buttonIconPosition={"left"}
            buttonLabel={t("upload_employee")}
            buttonHasLink={false}
            functions={() => setEnabledUploadEmployeePopup(true)}
          />
        </div>
      </div>
      <div className="relative flex justify-between items-center mb-4"></div>
      <div className="w-full overflow-auto scroll-smooth scrollbar min-h-[480px] mb-4">
        <table className="min-w-max w-full table-auto">
          <thead>
            <tr className="text-white font-bold text-sm leading-none border-b border-slate-200">
              <th className="py-4 px-2 text-left max-w-[240px] align-top sticky -top-6 z-10 bg-slate-900 rounded-tl-md">
                {t("first_name")}
              </th>
              <th className="py-4 px-2 text-left max-w-[240px] align-top sticky -top-6 z-10 bg-slate-900">
                {t("last_name")}
              </th>
              <th className="py-4 px-2 text-left max-w-[240px] align-top sticky -top-6 z-10 bg-slate-900">
                {t("email")}
              </th>
              <th className="py-4 px-2 text-left max-w-[240px] align-top sticky -top-6 z-10 bg-slate-900">
                {t("position")}
              </th>
              <th className="py-4 px-2 text-left max-w-[240px] align-top sticky -top-6 z-10 bg-slate-900">
                {t("date")}
              </th>
              <th className="py-4 px-2 text-left max-w-[240px] align-top sticky -top-6 z-10 bg-slate-900">
                {t("action")}
              </th>
            </tr>
          </thead>
          {totalDataCount > 0 ? (
            <tbody className="text-slate-700 text-sm font-light bg-white">
              {csvData.map((items, index) => {
                let firstName = "";
                let lastName = "";
                if (!items?.first_name) {
                  firstName = items?.name.split(/\s+/)[0];
                  lastName = items?.name.split(/\s+/)[1];
                } else {
                  firstName = items?.first_name;
                  lastName = items?.last_name;
                }
                return (
                  <tr className="border-b border-slate-200 group" key={index}>
                    <td className="py-3 px-2 font-semibold text-sm text-left max-w-[240px] align-middle">
                      {firstName}
                    </td>
                    <td className="py-3 px-2 font-semibold text-sm text-left max-w-[240px] align-middle">
                      {lastName || "N/A"}
                    </td>
                    <td className="py-3 px-2 font-semibold text-sm text-left max-w-[240px] align-middle">
                      {items?.email || "N/A"}
                    </td>
                    <td className="py-3 px-2 text-left max-w-[240px]">
                      <Select
                        xPlacement={"left"}
                        selectedValue={items?.designation}
                        dropdownClass={"!w-60"}
                        dropdownButtonLabelClass={"!font-bold"}
                        search={true}
                        dropdownData={[
                          { _id: "", label: t("select_position"), value: "" },
                          ...position.map((item) => ({
                            _id: item?._id,
                            label: item?.name,
                            value: item?._id,
                          })),
                        ]}
                        dropdownOptionBold={true}
                        getSelectedValue={(e) =>
                          handelUpdate(items._id, e._id, "designation", index)
                        }
                      />
                    </td>
                    <td className="py-3 px-2 font-semibold text-sm text-left max-w-[240px] align-middle">
                      {items && items?.created_at
                        ? moment(new Date(items.created_at)).format("ll")
                        : "N/A"}
                    </td>
                    <td className="py-3 px-2 font-semibold text-sm text-left max-w-[240px] align-middle">
                      {items?.role_details?.code !== "customer-admin" && (
                        <div className="flex items-start justify-start gap-2">
                          <div
                            className=""
                            data-tooltip-id={`buttonEdit${items?._id}`}
                            data-tooltip-place="right"
                          >
                            <Button
                              buttonClasses={
                                "!p-0 !flex !items-center !justify-center !text-base !bg-transparent !w-6 !h-6 !text-slate-400"
                              }
                              buttonType={"button"}
                              buttonIcon={"fa-solid fa-user-pen"}
                              buttonIconPosition={"left"}
                              buttonHasLink={false}
                              functions={() => {
                                setDetails(items);
                                setEnabledManageEmployeePopup(true);
                              }}
                            />
                            <Tooltip
                              id={`buttonEdit${items?._id}`}
                              className="!text-xs !bg-dark-teal-600 z-50 rounded py-3 px-6"
                              render={() => (
                                <div className="gap-x-1 gap-y-1">
                                  <div className="text-[13px] font-normal leading-none flex items-center">
                                    <div className="font-semibold">
                                      Click To Update Employee
                                    </div>
                                  </div>
                                </div>
                              )}
                            />
                          </div>
                          <div
                            className=""
                            data-tooltip-id={`buttons${items?._id}`}
                            data-tooltip-place="right"
                          >
                            <Button
                              buttonClasses={
                                "!p-0 !flex !items-center !justify-center !text-base !bg-transparent !w-6 !h-6 !text-rose-500"
                              }
                              buttonType={"button"}
                              buttonIcon={"fa-regular fa-trash-can"}
                              buttonIconPosition={"left"}
                              buttonHasLink={false}
                              functions={() => {
                                setCurrentId(items?._id);
                                setenabledDeletePopup(true);
                                setIsUpdate(false);
                              }}
                            />
                            <Tooltip
                              id={`buttons${items?._id}`}
                              className="!text-xs !bg-dark-teal-600 z-50 rounded py-3 px-6"
                              render={() => (
                                <div className="gap-x-1 gap-y-1">
                                  <div className="text-[13px] font-normal leading-none flex items-center">
                                    <div className="font-semibold">
                                      Click To Delete Employee
                                    </div>
                                  </div>
                                </div>
                              )}
                            />
                          </div>
                        </div>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          ) : (
            <tbody className="text-slate-700 text-sm font-light bg-white">
              <tr className="border-b border-slate-200 group">
                <td
                  className="py-3 px-2 font-semibold text-sm text-left max-w-[240px] align-middle"
                  colspan={6}
                >
                  {loading ? (
                    <TableSkeleton tableImage={false} />
                  ) : (
                    <NoDataFound label={t("no_data_found")} />
                  )}
                </td>
              </tr>
            </tbody>
          )}
        </table>
      </div>
      {noOfPage > 1 ? (
        <div className="flex justify-center sm:justify-between my-4">
          <div>
            <p>
              {t("showing")}: {startDataCount} to {endDataCount} of{" "}
              {totalDataCount}
            </p>
          </div>
          <ReactPaginate
            breakLabel="..."
            breakClassName="w-8 h-8 flex justify-center items-center rounded hover:bg-slate-200"
            nextLabel={<i className="fa-regular fa-fw fa-chevron-right"></i>}
            nextClassName="w-8 h-8 flex justify-center items-center rounded hover:bg-slate-200"
            onPageChange={handlePageClick}
            pageRangeDisplayed={3}
            pageCount={noOfPage}
            containerClassName="flex justify-center items-center text-slate-80 text-sm font-medium mt-8 lg:mt-0 space-x-2"
            activeClassName="hover:bg-teal-500 bg-teal-500 text-white"
            pageLinkClassName="flex justify-center items-center w-full h-full"
            previousLabel={<i className="fa-regular fa-fw fa-chevron-left"></i>}
            pageClassName="w-8 h-8 flex justify-center items-center rounded hover:bg-slate-200"
            previousClassName="w-8 h-8 flex justify-center items-center rounded hover:bg-slate-200"
            renderOnZeroPageCount={null}
          />
        </div>
      ) : (
        <div className="flex justify-center sm:justify-between my-4">
          {totalDataCount > 0 ? (
            <div>
              <p>
                {t("showing")}: {startDataCount} to {endDataCount} of{" "}
                {totalDataCount}
              </p>
            </div>
          ) : (
            ""
          )}
        </div>
      )}
      {enabledManageEmployeePopup && (
        <ManageEmployeePopup
          isOpen={enabledManageEmployeePopup}
          setIsOpen={(val) => setEnabledManageEmployeePopup(val)}
          getActionValue={(obj) => {
            setActionValue(obj);
          }}
          data={details}
          setDetails={setDetails}
        />
      )}
      {enabledDeletePopup && (
        <DeletePopup
          isOpen={enabledDeletePopup}
          setIsOpen={(val) => setenabledDeletePopup(val)}
          currentId={currentId}
          getActionValue={(obj) => {
            setActionValue(obj);
            setenabledDeletePopup(false);
            setCurrentId("");
          }}
        />
      )}
      <EmployeeUploadPopup
        isOpen={enabledUploadEmployeePopup}
        setIsOpen={(val) => setEnabledUploadEmployeePopup(val)}
        currentId={currentId}
        loadList={loadList}
        loadPositionList={loadPositionList}
        getActionValue={(obj) => {
          setActionValue(obj);
          setEnabledUploadEmployeePopup(false);
          setCurrentId("");
        }}
      />
    </>
  );
};

export default CompanyEmployees;
